import { AnalyticsHelper } from '@/utilities/analyticsHelper';
import { IdentityProviders } from '@/lib/SocialProviderStore';

const ENROLLMENT_FLOW = 'MW VHP';
const CTA_CLICKED = 'Next';
const MEMBER_TYPE = 'Seeker';
export const MEMBER_ENROLLED_EVENT_NAME = 'Member Enrolled';
export const MEMBER_EMAIL_ALREADY_REGISTERED = 'MemberEmailAlreadyRegistered';
export const MEMBER_EMAIL_ALREADY_REGISTERED_EVENT_NAME = 'Email Already Registered';

export const phoneNumberRegex = /^\(\d{3}\) \d{3}-\d{4}$/;

export enum SignUpType {
  EMAIL = 'Email',
  SOCIAL = 'Social',
}
interface analyticsDataParams {
  enrollmentStep: string;
  enrollmentFlow?: string;
  ctaClicked?: string;
  memberType?: string;
  finalStep?: boolean;
  caregiverCount?: number;
  signUpType?: SignUpType;
  signUpMethod?: IdentityProviders | SignUpType.EMAIL;
}

const analyticsDataBuilder = (params: analyticsDataParams) => {
  const { signUpType, signUpMethod, ...restParams } = params;
  const data = {
    ...restParams,
    enrollment_flow: params.enrollmentFlow || ENROLLMENT_FLOW,
    cta_clicked: params.ctaClicked || CTA_CLICKED,
    member_type: params.memberType || MEMBER_TYPE,
    final_step: params.finalStep || false,
    ...(signUpType ? { sign_up_type: params.signUpType } : {}),
    ...(signUpMethod ? { sign_up_method: params.signUpMethod } : {}),
  };
  return data;
};

export default analyticsDataBuilder;

export const formSubmissionUtil = (formik: any, eventName: string, data: any) => {
  if (!formik.isValid || formik.isSubmitting) {
    return;
  }
  AnalyticsHelper.logEvent({
    name: eventName,
    data,
  });

  formik.handleSubmit();
};
